import Vue from 'vue'

export default {
  UPDATE_FAQSECTION (state, value) {
    Vue.set(state, 'faqsections', value);
  },
  SET_FAQSECTIONS (state, value) {
    this.commit('UPDATE_FAQSECTION', value);
  },
  SET_SELECTED_FAQSECTION (state,  value ) {
    Vue.set(state, 'selectedFaqsection', value);
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/faqsections/mutations.js